// FilterDropdown.jsx
import { useEffect } from "react";
import PropTypes from "prop-types";
import { Filter } from 'lucide-react';
import { RxFontBold } from "react-icons/rx";

export default function FilterDropdown({ value, onChange, options, label = "Select an option from the catalog" }) {
  useEffect(() => {
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  return (
    <div>
      <label htmlFor="dropdown" style={styles.label}>{label}</label>
      <div style={styles.wrapper}>
        <Filter className="w-5 h-5 text-gray-500" />
        <select
          id="dropdown"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={styles.select}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

FilterDropdown.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ).isRequired,
  label: PropTypes.string,
};

const styles = {
  label: {
    fontWeight: 800,
    marginBottom: 8,
    display: "block",
    textAlign: "center",
    color: "#db3636ff",
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    background: "#fff",
    padding: "14px 20px",
    borderRadius: 10,
    boxShadow: "0 4px 12px rgba(255, 140, 0, 0.2)",
    border: "1px solid #ffb066",
    maxWidth: 360,
    margin: "auto",
  },
  icon: {
    width: 24,
    height: 24,
    stroke: "#ff7f50",
    flexShrink: 0,
  },
  select: {
    flex: 1,
    padding: 10,
    fontSize: 16,
    border: "1px solid #ffb066",
    borderRadius: 6,
    backgroundColor: "#fff3e0",
    color: "#d35400",
  },
};
